import gate from "@gate/index";
import { setProfileFile } from "@store/reducers/user";
import { Button } from "components";
import { useRouter } from "next/router";
import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getCroppedImg } from "src/utils/canvasUtils";

function Index({ onClose, back }: any) {
  const router = useRouter();
  const state: any = useSelector((state) => state);
  const dispatch = useDispatch();
  const { mutate, isLoading } = useMutation(gate.uploadProfilePic);

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [imageSrc, setImageSrc] = React.useState(state.user.file);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [rotation, setRotation] = useState(0);

  const [zoom, setZoom] = useState<number>(1);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleZoom = (action: number) => {
    if (action == 0) {
      setZoom(zoom + 0.1);
    } else if (action == 1 && zoom > 1) {
      setZoom(zoom - 0.1);
    }
  };

  function urltoFile(url: string, filename: string, mimeType: string) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation
      );

      //Usage example:
      const formData: any = new FormData();
      urltoFile(croppedImage, "hello.png", "image/jpeg").then(function (file) {
        formData.append("image", file);
        mutate(formData, {
          onSuccess: () => {
            toast.success("پروفایل شما با موفقیت ویرایش شد!");
            onClose();
          },
        });
      });
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  return (
    <div>
      <div className="h-full w-full px-10">
        {/* <div className="bg-green-550 absolute top-0 left-0 right-0 z-10 flex h-14 items-center justify-between px-10 text-white">
                    <span>بزرگ نمایی و حرکت دادن</span>

                    <WhiteClose className="cursor-pointer" onClick={onClose} />
                </div>
                <div className="absolute top-20 left-0 right-10 bottom-0 z-10 flex h-16 flex-col">
                    <button
                        className="w-12 rounded-t bg-white p-3 text-xl transition-all hover:opacity-80"
                        onClick={() => handleZoom(0)}
                    >
                        +
                    </button>
                    <button
                        className="w-12 rounded-b bg-white p-3 text-xl transition-all hover:opacity-80"
                        onClick={() => handleZoom(1)}
                    >
                        -
                    </button>
                </div> */}
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={3 / 3}
          cropShape="round"
          classes={{ containerClassName: "w-full h-full" }}
          showGrid={false}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </div>
      <div className="absolute -bottom-24 left-0 mx-auto mb-1 flex w-full justify-center md:-bottom-[52px] md:justify-end">
        <Button
          onClick={() => {
            dispatch(setProfileFile(null));
            setImageSrc(null);
            back();
          }}
          spinnerColor="#37bfb4"
          className="ml-5 w-28 whitespace-nowrap rounded-md border border-[#74788D] px-5 py-1.5 text-[#74788D]"
        >
          تلاش مجدد
        </Button>
        <Button
          onClick={showCroppedImage}
          spinnerColor="#37bfb4"
          isLoading={isLoading}
          className="w-28 rounded-md bg-blue px-5 py-1.5 text-white"
        >
          ثبت
        </Button>
      </div>
    </div>
  );
}

export default Index;
